import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom"; 
import './index.css';
import './assets/css/remixicon.css';
import './assets/css/lib/bootstrap.min.css';
import './assets/css/lib/apexcharts.css';
import './assets/css/lib/dataTables.min.css';
import './assets/css/lib/editor.atom-one-dark.min.css';
import './assets/css/lib/editor.quill.snow.css';
import './assets/css/lib/flatpickr.min.css';
import './assets/css/lib/full-calendar.css';
import './assets/css/lib/jquery-jvectormap-2.0.5.css';
import './assets/css/lib/magnific-popup.css';
import './assets/css/lib/slick.css';
import './assets/css/lib/prism.css';
import './assets/css/lib/file-upload.css';
import './assets/css/lib/audioplayer.css';
import './assets/css/lib/animate.min.css';
import './assets/css/style.css';
import './assets/css/extra.css';
import App from './App';
import store from "./store";
import { AxiosSetup } from './utils/helpers/api.helpers';

AxiosSetup();

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
